import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { getRecipientsByExecutionService } from '../../services/campersServices';
import PaginatedComponent from '../common/Pagination/PaginationComponent';
import { Modal } from 'react-bootstrap';

const LIMIT = 10;
const MESSAGE_TYPE_LABEL = { 1: 'SMS', 2: 'App Message', 3: 'Email' };

const getDisplayHtml = (html) => {
    if (!html) return html;
    if (/<!DOCTYPE|<html/i.test(html)) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const td = doc.querySelector('table td');
        if (td) {
            const contentHtml = Array.from(td.children)
                .filter(el => el.tagName !== 'BR')
                .map(el => el.outerHTML)
                .join('');
            if (contentHtml) return contentHtml;
        }
        return doc.body.innerHTML;
    }
    return html;
};

const AutomationAuditRecipients = () => {
    const history = useHistory();
    const { executionId } = useParams();
    const location = useLocation();
    
    // Grab metadata passed from the previous page if available
    const { executionDate } = location.state || {};

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const [previewContent, setPreviewContent] = useState(null);
    // const [sentDate, setSentDate] = useState('');

    const fetchRecipients = useCallback(() => {
        setLoading(true);
        // page - 1 because your backend uses 0-based indexing
        const query = `?executionId=${executionId}&page=${page - 1}&limit=${LIMIT}&search=${encodeURIComponent(search)}`;
        
        getRecipientsByExecutionService(query).then(res => {
            setLoading(false);
            if (res?.data?.responseData) {
                const result = res.data.responseData;
                setData(result.recipients || []);
                setTotalCount(result.pagination.total || 0);
            }
            if (res?.data?.time) {
                // setSentDate(new Date(res.data.time).toLocaleString());
            }
        }).catch(() => setLoading(false));
    }, [executionId, page, search]);

    useEffect(() => {
        fetchRecipients();
    }, [fetchRecipients]);

    return (
        <div className="body_container">
            <div className="container">
                <div className='inner_inbox_page'>
                    <div className="d-flex align-items-center mb-3 mt-4">
                        <span className="btn btn-primary btn-sm me-3" onClick={() => history.goBack()}>&#8592; Back</span>
                        <h6 className="mb-0">Recipients for Execution: <b>{executionDate}</b></h6>
                    </div>

                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search by user name or subject..."
                            value={search}
                            onChange={e => { setSearch(e.target.value); setPage(1); }}
                        />
                    </div>

                    {loading ? (
                        <div className="text-center py-4">Loading...</div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>User Name</th>
                                        <th>Message Type</th>
                                        <th>Subject</th>
                                        <th>Content</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((r, i) => (
                                        <tr key={i}>
                                            <td>{i + 1 + (page - 1) * LIMIT}</td>
                                            <td>{r.userName || '—'}</td>
                                            <td>{MESSAGE_TYPE_LABEL[r.messageType] || '—'}</td>
                                            <td>{r.subject || '—'}</td>
                                            <td>
                                                {r.html ? (
                                                    <span className="btn btn-primary btn-sm" onClick={() => setPreviewContent(r.html)}>View</span>
                                                ) : '—'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {totalCount > LIMIT && (
                        <div className="d-flex justify-content-center mt-4">
                            <PaginatedComponent
                                activePage={page}
                                itemsCountPerPage={LIMIT}
                                totalItemsCount={totalCount}
                                onPageChange={setPage}
                            />
                        </div>
                    )}
                </div>
            </div>

            {/* Content Preview Modal remains useful for the HTML body */}
            <Modal show={!!previewContent} onHide={() => setPreviewContent(null)} size="lg" centered scrollable>
                <Modal.Header className="d-flex justify-content-between align-items-center">
                    <Modal.Title>Message Preview</Modal.Title>
                    <button type="button" className="btn-close" onClick={() => setPreviewContent(null)} aria-label="Close" />
                </Modal.Header>
                <Modal.Body style={{ overflowY: 'auto', maxHeight: '70vh' }}>
                    <div style={{ overflowX: 'auto', wordBreak: 'break-word' }} dangerouslySetInnerHTML={{ __html: getDisplayHtml(previewContent) }} />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default AutomationAuditRecipients;